export default __webpack_public_path__ + "static/media/dentist (1).61750f3a.jpg";